import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent, HeaderComponent, LoginDialogComponent, SidebarMenuComponent } from '@core/components';
import { LayoutComponent } from '@core/layouts';
import { MaterialModule } from '@core/material';
import { MstMessageImpurePipe, MstMessagePipe } from './pipes';
import {
  CustomPaginatorDirective,
  NoWhitespaceDirective,
  InputMaxLengthByteDirective,
  LatinOnlyDirective,
  AppOnlyNumberDirective,
  VersionInputDirective,
} from '@core/directives';
import {
  SameDateDisplayPipe,
} from '@core/pipes';

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SidebarMenuComponent,
  LayoutComponent,
  LoginDialogComponent,
];

const DIRECTIVES = [
  CustomPaginatorDirective,
  NoWhitespaceDirective,
  InputMaxLengthByteDirective,
  LatinOnlyDirective,
  AppOnlyNumberDirective,
  VersionInputDirective,
];
const PIPES = [
  SameDateDisplayPipe,
  MstMessagePipe,
  MstMessageImpurePipe,
];

@NgModule({
  imports: [CommonModule, RouterModule, MaterialModule, TranslateModule],
  exports: [CommonModule, MaterialModule, TranslateModule, ...DIRECTIVES, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
})
export class CoreModule { }
